import Button from "@/common/components/Button"
import GoBackButton from "@/common/components/GoBackButton";
import { ImageWithPlaceholder } from "@/common/components/ImageWithPlaceholder";
import ReasonModal from "@/common/components/ReasonModal";
import { useGoBack } from "@/common/hooks/useGoBack"
import { useArchiveEstablishmentLead } from "@/features/establishmentLeadsFunnel/hooks/useArchiveEstablishmentLead"
import { useIsMutating, useQueryClient } from "@tanstack/react-query"
import { Building2Icon } from "lucide-react";
import { useState } from "react";

interface LeadHeaderProps {
  establishmentLeadId: string
  display_name?: string
  url?: string
  showArchiveButton?: boolean
  archived_at?: string
  buttons?: JSX.Element
}

export const LeadHeader = ({
  establishmentLeadId,
  display_name,
  url,
  showArchiveButton,
  archived_at,
  buttons,
}: LeadHeaderProps) => {
  const goBack = useGoBack()
  const queryClient = useQueryClient()
  const isMutating = !!useIsMutating()

  const [showReasonModal, setShowReasonModal] = useState(false);

  const archiveUnarchiveOperationKlass = archived_at ? 'Admin::Funnel::Establishment::Leads::Unarchive' : 'Admin::Funnel::Establishment::Leads::Archive'

  const {
    mutate: archiveEstablishmentLead,
    isError: archiveEstablishmentLeadIsError,
  } = useArchiveEstablishmentLead({
    establishmentLeadId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['establishmentLead', establishmentLeadId] })
      goBack({ fallback: '/establishment-leads', searchLastRouteFromFallback: true })
    },
  })

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-2 items-center">
          <GoBackButton
            fallback="/establishment-leads"
            searchLastRouteIgnoringFilters
          />

          <ImageWithPlaceholder
            url={url}
            placeholderIcon={Building2Icon}
            className="size-10"
            iconClassName="size-7"
          />

          <p className="text-white-400 font-normal" data-testid="header_establishment_display_name">{display_name}</p>
          {showArchiveButton && (
            <Button
              type="button"
              variant="outline-error"
              operationKlassToCheckPermission={archiveUnarchiveOperationKlass}
              onClick={() => setShowReasonModal(true)}
              disabled={isMutating}
            >
              {archived_at ? 'Desarquivar' : 'Arquivar'}
            </Button>
          )}
        </div>
        {buttons}
      </div>
      {archiveEstablishmentLeadIsError && (
        <p className="text-sm text-danger-soft">Ocorreu um erro no servidor, cheque os campos e tente novamente</p>
      )}
      <ReasonModal
        isOpen={showReasonModal}
        setIsOpen={setShowReasonModal}
        onSubmit={(reasonData) => archiveEstablishmentLead({
          log_reason: reasonData,
          newStatus: archived_at ? 'unarchive' : 'archive'
        })}
      />
    </div>
  )
}
